import { normalizeValue } from './ValueNormalizer';

export const AxleType = [
  'Steering',
  'Drives',
  'Jeep',
  'Trailer',
  'Booster',
] as const;

export const normalizeAxleType = (
  axleType?: string | null,
): string | undefined => {
  return normalizeValue(AxleType, axleType);
};
